import { z } from "zod";

export const contactSchema = z
  .object({
    firstName: z
      .string()
      .trim()
      .min(1, "First name is required")
      .max(50, "First name must not exceed 50 characters")
      .regex(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "First name can only contain letters and spaces"),

    lastName: z
      .string()
      .trim()
      .min(1, "Last name is required")
      .max(50, "Last name must not exceed 50 characters")
      .regex(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Last name can only contain letters and spaces"),

    contactEmail: z
      .string()
      .trim()
      .min(1, "Email address is required")
      .max(50, "Email address must not exceed 50 characters")
      .email("Please enter a valid email address"),

    mobileNoCountryCode: z
      .string()
      .trim()
      .min(1, "Country code is required"),

    contactPhone: z
      .string()
      .trim()
      .min(7, "Please enter a valid mobile number")
      .max(15, "Mobile number must not exceed 15 digits")
      .regex(/^\d+$/, "Mobile number can only contain digits"),
  })
  .superRefine((data, ctx) => {
    if (data.mobileNoCountryCode === "+60") {
      const phone = data.contactPhone;

      // Malaysia mobile number must be exactly 9 digits
      if ((phone.length !== 9 && phone.length !== 10)) {
        ctx.addIssue({
          code: "custom",
          path: ["contactPhone"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }

      // Cannot start with 0
      if (phone.startsWith("0")) {
        ctx.addIssue({
          code: "custom",
          path: ["contactPhone"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }
    }
  });

export type ContactValues = z.infer<typeof contactSchema>;

